import React, { useEffect, useRef, useState } from "react";
import styles from "./productList.module.scss";
import { Outlet } from "react-router-dom";
import NavTabs from "../../components/mui/tabs/NavTab";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
import { useDispatch } from "react-redux";
import { getAllCategory, getAllProduct } from "../../store/actions";
const tabs = [
  {
    id: "1",
    title: "Active",
    link: "/products/productMgmt",
  },
  {
    id: "2",
    title: "Disabled",
    link: "/products/productMgmt/disabled",
  },
  {
    id: "3",
    title: "Deleted",
    link: "/products/productMgmt/deleted",
  },
];

const ProductList = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllProduct());
    dispatch(getAllCategory());
  });
  return (
    <div className={styles.container}>
      <StatusCard
        leftContent="PRODUCTS" // or any icon/component
      />
      <div className={styles.top}>
        <NavTabs data={tabs} variant={"fullWidth"} />
      </div>

      <div className={styles.bottom}>
        <Outlet />
      </div>
    </div>
  );
};

export default ProductList;
